import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import WtiLoader from './WtiLoader';

const ADMIN_ROLES = new Set(['MANAGER', 'ADMIN', 'SUPER_ADMIN']);

interface AdminRouteProps {
  children: React.ReactElement;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <WtiLoader fullPage message="Loading…" />;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!user.role || !ADMIN_ROLES.has(user.role)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default AdminRoute;
